import { render, staticRenderFns } from "./NewQuestionModal.vue?vue&type=template&id=67f1bc26&"
import script from "./NewQuestionModal.vue?vue&type=script&lang=js&"
export * from "./NewQuestionModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports